import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import InfoIcon from '@mui/icons-material/Info';
import ModeEditOutlineIcon from '@mui/icons-material/ModeEditOutline';
import UploadIcon from '@mui/icons-material/Upload';
import { GridActionsCellItem } from '@mui/x-data-grid';

import TableActionButtons from '../../components/shared/TableActionButtons/TableActionButtons';

const useCodeGroupTableColumns = (
  goToInfoPage,
  deleteItem,
  editItem,
  uploadItem,
  downloadItem,
  apiRef,
  columnPermissions = {},
) => {
  const {
    canViewValues = false,
    canEdit = false,
    canUpload = false,
    canDownload = false,
    canDelete = false,
  } = columnPermissions;

  const columnsData = [
    {
      field: 'title',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 120,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.title;
      },
    },
    {
      field: 'typeDisplay',
      headerName: 'نوع',
      flex: 1,
      minWidth: 120,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.typeDisplay;
      },
    },
    {
      field: 'length',
      headerName: 'طول رشته',
      flex: 1,
      minWidth: 120,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.length;
      },
    },

    {
      field: 'actions',
      headerName: 'عملیات',
      type: 'actions',
      flex: 0.5,
      align: 'right',
      minWidth: 250,
      getActions: params => {
        const buttons = [
          canViewValues
            ? {
                label: 'مقادیر',
                Icon: InfoIcon,
                onClick: goToInfoPage(params.row),
                color: 'primary',
              }
            : null,
          canEdit
            ? {
                label: 'ویرایش',
                Icon: ModeEditOutlineIcon,
                onClick: editItem(params.row),
                color: 'info',
              }
            : null,
        ].filter(Boolean);

        return [
          buttons.length ? (
            <TableActionButtons key={10} buttons={buttons} />
          ) : null,
          canDelete ? (
            <GridActionsCellItem
              key={2}
              icon={<DeleteIcon />}
              label="حذف"
              onClick={deleteItem(params.row)}
              showInMenu
            />
          ) : null,
          canUpload ? (
            <GridActionsCellItem
              key={3}
              icon={<UploadIcon />}
              label="آپلود"
              onClick={uploadItem(params.row)}
              showInMenu
            />
          ) : null,
          canDownload ? (
            <GridActionsCellItem
              key={4}
              icon={<DownloadIcon />}
              label="دانلود"
              onClick={downloadItem(params.row)}
              showInMenu
            />
          ) : null,
        ].filter(Boolean);
      },
    },
  ];

  return [columnsData, apiRef];
};

export default useCodeGroupTableColumns;
